import styles from './BackOrderList.module.css';
import React from 'react';
import { ModuleHeader, Text, Image } from 'ui';
import clsx from 'clsx';
import { useTranslations } from '~/services/cms';
import { useBackorder } from '../../hooks';
import { BackorderItem } from 'api-types/src/data-contract/auto-generated/backorder-model';
import { isJPG } from 'utils';


const isJPGroup = isJPG()


export const BackOrderList = () => {
    const { data: backorderList } = useBackorder();
    const translate = useTranslations();
    const stocks = Array.isArray(backorderList) && backorderList.length > 0 ? [backorderList[0].ShowJPStock] : [];
    const getStockStatus = (trafficLightValue: number, reliableDate?: string): string => {
        switch (trafficLightValue) {
            case 0:
                return translate('stockStatus.notAvailable')
            case 1:
                if (isJPGroup) {
                    return `${translate('stockStatus.jpgAvailable')} ${stocks}`
                } else
                    return translate('stockStatus.howAvailable')

            case 2:
                return translate('stockStatus.shippingWarehouse')
            case 3:
                const dateString = reliableDate && reliableDate !== '1900-01-01 00:00:00.0'
                    ? ` ${new Date(reliableDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })}`
                    : '';
                return `${translate('stockStatus.expectedDelivery')}${dateString}`;
            default:
                return ''
        }
    };

    return (
        <div className={styles.container}>
            <ModuleHeader headline={'Backorders'} variant="display3" />
            <div className={styles.gridRoot}>
                {Array.isArray(backorderList) && backorderList.length > 0 ? (
                    backorderList.map((item: BackorderItem) => (

                        <div className={styles.divItem} key={item.ItemID}>

                            <div>
                                <Text className={clsx([styles.partNo, styles.item])}>
                                    {/* TODO translation  */}
                                    Product Image
                                </Text>
                                <Text variant='bodyExtraSmall'
                                    fontWeight='light' className={clsx([styles.partQty, styles.item, styles.image])}>
                                    <Image height={20} width={20} alt={item.ItemName} src={item.PictureUrl?.toString() || ''} />
                                </Text>
                            </div>
                            <div >
                                <div className={styles.itemID}>
                                    <Text className={clsx([styles.partNo, styles.item])}  >
                                        {/* TODO translation  */}
                                        Item ID

                                    </Text>

                                </div>
                                <Text className={clsx([styles.partData, styles.item])}>
                                    {item.ItemID}
                                </Text>
                            </div>
                            <div>
                                <div className={styles.orderNumber}>
                                    <Text className={clsx([styles.partNo, styles.item])} >
                                        {/* TODO translation  */}
                                        Order Number

                                    </Text>

                                </div>
                                <Text className={clsx([styles.partData, styles.item])}>
                                    {item.OrderNumber}
                                </Text>
                            </div>
                            <div>
                                <div className={styles.purchaseNo}>
                                    <Text className={clsx([styles.partNo, styles.item])} >
                                        {/* TODO translation  */}
                                        Purchase Number

                                    </Text>

                                </div>
                                <Text className={clsx([styles.partData, styles.item])}>
                                    {item.PurchaseNo}
                                </Text>
                            </div>
                            <div>
                                <Text className={clsx([styles.partNo, styles.item])}>
                                    {translate('profile.name')}
                                </Text>
                                <Text className={clsx([styles.partData, styles.item])}>
                                    {item.ItemName || '-'}
                                </Text>
                            </div>
                            <div>
                                <Text className={clsx([styles.description, styles.item])}>
                                    PriceQuantity
                                </Text>
                                <Text className={clsx([styles.partDesc, styles.item])}>
                                    {item.Price_Qty || '-'}
                                </Text>
                            </div>
                            <div>
                                <Text className={clsx([styles.quantity, styles.item])}>
                                    {translate('profile.quantity')}
                                </Text>
                                <Text className={clsx([styles.partQty, styles.item])}>{item.Qty}</Text>
                            </div>
                            <div>
                                <Text className={clsx([styles.quantity, styles.item])}>
                                    Price Total
                                </Text>
                                <Text className={clsx([styles.partQty, styles.item])}>{item.Price_Total}</Text>
                            </div>
                            <div>
                                <Text className={clsx([styles.quantity, styles.item])}>
                                    Status
                                </Text>
                                <Text variant='bodyExtraSmall'
                                    fontWeight='light' className={clsx([styles.partQty, styles.item, styles.statusText])}>
                                    <span className={styles[`status${item.JPG_Trafficlight || 0}`]} />
                                    {getStockStatus(item.JPG_Trafficlight || 0, item.ReliableDate)}

                                </Text>
                            </div>

                        </div>
                    ))
                ) : null}
            </div>
        </div>
    );
};

export default BackOrderList;